import { render, staticRenderFns } from "./square.mpx?vue&type=template&id=02a53325&isComponent&outputPath=components%2Fsquare01aa55e2%2Findex"
import script from "./square.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fsquare01aa55e2%2Findex"
export * from "./square.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fsquare01aa55e2%2Findex"
import style0 from "./square.mpx?vue&type=style&index=0&id=02a53325&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_01aa55e2%22%7D&isComponent&outputPath=components%2Fsquare01aa55e2%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports